/**
 * OZONE — color-split + asset swatches for JS-built product grids
 * (recently viewed / predictive helpers that call theme.buildProductGridItem)
 */
(function () {
  if (!window.theme || typeof theme.buildProductGridItem !== 'function') return;

  function handleize(str) {
    return String(str || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-+/g, '-');
  }

  function isColorOption(name) {
    var n = String(name || '').toLowerCase().trim();
    var trigger = String((theme.settings && theme.settings.eyesonoffColorTrigger) || 'color').toLowerCase();
    return (
      n === 'colore' ||
      n === 'color' ||
      n === 'colour' ||
      n === trigger ||
      (trigger && n.indexOf(trigger) !== -1)
    );
  }

  function variantImageSrc(variant, product) {
    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    if (product.featured_image) return product.featured_image;
    return null;
  }

  function withResponsiveImages(product, imageSrc) {
    if (!imageSrc || !theme.Images || typeof theme.Images.buildImagePath !== 'function') {
      return product;
    }
    var widths = [180, 360, 540, 720, 900];
    product.image_responsive_url = theme.Images.buildImagePath(imageSrc);
    product.image_responsive_urls = theme.Images.buildImagePath(imageSrc, widths);
    return product;
  }

  function expandByColor(product) {
    if (!theme.settings || !theme.settings.eyesonoffSplitColors) {
      return [product];
    }

    var options = product.options || [];
    var colorIndex = -1;
    for (var i = 0; i < options.length; i++) {
      if (isColorOption(options[i])) {
        colorIndex = i;
        break;
      }
    }
    if (colorIndex < 0 || !product.variants || !product.variants.length) {
      return [product];
    }

    var seen = {};
    var cards = [];

    product.variants.forEach(function (variant) {
      var colorName = variant.options && variant.options[colorIndex];
      if (!colorName) return;
      var key = handleize(colorName);
      if (!key || seen[key]) return;
      seen[key] = true;

      // Prefer an available variant of this color when possible
      var rep = variant;
      for (var v = 0; v < product.variants.length; v++) {
        var candidate = product.variants[v];
        if (
          candidate.options &&
          handleize(candidate.options[colorIndex]) === key &&
          candidate.available
        ) {
          rep = candidate;
          break;
        }
      }

      var card = Object.assign({}, product);
      card.title = product.title + ' – ' + colorName;
      card.url = (product.url || '') + (String(product.url || '').indexOf('?') === -1 ? '?' : '&') + 'variant=' + rep.id;
      card.price_min = typeof rep.price !== 'undefined' ? rep.price : product.price_min;
      withResponsiveImages(card, variantImageSrc(rep, product));
      cards.push(card);
    });

    return cards.length > 1 ? cards : [product];
  }

  var originalBuild = theme.buildProductGridItem.bind(theme);

  theme.buildProductGridItem = function (items, gridWidth, rowOf, imageSizes) {
    var expanded = [];
    (items || []).forEach(function (product) {
      if (!product) return;
      expandByColor(product).forEach(function (card) {
        expanded.push(card);
      });
    });
    return originalBuild(expanded, gridWidth, rowOf, imageSizes);
  };
})();
